import React from 'react';
import { useQuery } from '../../../../hooks/UseQuery';
import { StyledTableRow } from '../helpers/module.styled';
import CustomSelect from '../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';
import { levels } from '../../helpers/constant';
import { LevelSymbolImg } from '../../assets/levelSymbols';

export const TableRowComponent = React.memo(
  ({ key, item, index, updateModuleData }: any) => {
    const isView = useQuery('isView') === 'true' ? true : false;

    const handleInputChange = (
      fieldName: string,
      value: string | number | null,
      ishandleCalc: boolean = false
    ) => {
      updateModuleData(
        'row',
        index,
        fieldName,
        { [fieldName]: value },
        ishandleCalc
      );
    };

    return (
      <React.Fragment key={key}>
        <StyledTableRow index={index}>
          <td>{item.s_no}</td>
          <td>
            {isView ? (
              item?.current_level
            ) : (
              <CustomSelect
                name="current_level"
                value={item.current_level || ''}
                onChange={(e: any) => {
                  handleInputChange(e.target.name, e.target.value);
                }}
              >
                <MenuItem value="">None</MenuItem>
                {levels.map((item) => (
                  <MenuItem value={item.value}>{item.name}</MenuItem>
                ))}
              </CustomSelect>
            )}
          </td>
          <td>{item?.minimum_level}</td>
          <td>
            <img
              src={LevelSymbolImg[item?.minimum_level || '']}
              width={50}
              height={'auto'}
            />
          </td>
          <td>{item.traning_topic}</td>
        </StyledTableRow>
      </React.Fragment>
    );
  },
  (prevProps, nextProps) => {
    // Check if the relevant data for this row has changed
    return (
      prevProps.item === nextProps.item && prevProps.index === nextProps.index
    );
  }
);
